import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";

import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import  "./../assets/css/custom.css"; 
const CustomerInvoicePayment = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [invoicestatus, setInvoicestatus] = useState([]);
  const [value, setValue] = useState({});
   const [paymentdata, setPaymentdata] = useState([]);
 
  let customer_id = localStorage.getItem("customer_id");
  let season_id = localStorage.getItem("season_id");


  useEffect(() => {
    axios
      .get(`/customerportal/invoices-payments/${customer_id+'-'+season_id}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data);
          setData(response.data.data.invoices);
          setValue(response.data.data.customer);
          
          setPaymentdata(response.data.data.payments);
        setInvoicestatus(response.data.data.overview);
        }
      })
      .catch((error) => {
        toast.error(error);
      });

  
 

  }, [customer_id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  
const InvoiceLink = ({ row }) => (
  <a href={`/customerportal/invoices-payments-view/${row.original.id}`}>
    {row.original.invoice_number}
  </a>
);

InvoiceLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      invoice_number: PropTypes.string,
    }),
  }).isRequired,
};

const TotalPaidLink = ({ row }) => (
  <span href={`/customerportal/invoices-payments-all-view/${row.original.id}`}>
 {Number(row.original.paid).toFixed(2)}   </span>
);

TotalPaidLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      paid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

const CreditNoteLink = ({ row }) => {
  const creditNote = row.original.total_credit_note;
  const creditNoteId = row.original.credit_note_id;

  if (creditNote > 0) {
    return (
      <span href={`/customerportal/invoices-payments-view/${creditNoteId}`}>
        {creditNote.toFixed(2)}
      </span>
    );
  }
  return <span></span>;
};

CreditNoteLink.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_credit_note: PropTypes.number,
      credit_note_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};


const StatusCell = ({ row }) => {
  const status = row.original.invoicing_status?.title || '';
  const statusid = row.original.invoicing_status?.id || '';
  const bgColor = row.original.invoicing_status?.bg_color || '#eee';
  //const textColor = row.original.invoicing_status?.color || '#333';
  
    let iconClass = '';
    let bg_color = '';

  if (statusid == 1) {
    iconClass = 'fa fa-check';
    bg_color ='#0080006b';
  } else if (statusid == 2) {
    iconClass = 'fa fa-hourglass-2';
    bg_color ='#0000ff78';
  } else {
    iconClass = 'fa fa-times';
    bg_color ='#ff00005e';
  }
  return (
    <p
      style={{
        backgroundColor: bg_color,
        color: bgColor,
        fontWeight:'600',
        padding: '5px 10px',
        borderRadius: '4px',
        display: 'inline-block',
        textTransform: 'capitalize',
      }}
    >
      {status} <i className={iconClass}></i>
    </p>
  );
};

StatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      invoicing_status: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  }).isRequired,
};
// Column definitions
const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => `${row.invoice_number}`,
    Cell: InvoiceLink,
  },
  {
    accessorKey: 'po_order_number',
    header: 'PO Order Number',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    header: 'Customer',
    accessorFn: (row) =>
      row.customer_detail ? row.customer_detail.company_name : '',
  },
  {
    header: 'Total Sales',
   // accessorFn: (row) => `${row.total_amount}`,
      accessorFn: (row) => Number(row.total_amount).toFixed(2),

  },
  {
    header: 'Total Paid',
    Cell: TotalPaidLink,
  },
  {
    header: 'Credit Balance',
    // accessorFn: (row) =>  `${row.total_amount - row.paid - row.total_credit_note}`,
      accessorFn: (row) => (Number(row.total_amount) - Number(row.paid) - Number(row.total_credit_note)).toFixed(2),
  },
  {
    header: 'Credit Note',
    Cell: CreditNoteLink,
  },
  {
  header: 'Invoice Status',
  accessorKey: 'invoicing_status.title',
  Cell: StatusCell,
}
];

const payments_columns =
[
  {
    accessorKey: 'payment_date', //normal accessorKey
    header: 'Payment Date',
  },
  {
    // accessorKey: 'payment_amount', //normal accessorKey
     accessorFn: (row) => Number(row.payment_amount).toFixed(2),
    header: 'Payment Amount',
  },
  {
    accessorKey: 'exchange_date', //normal accessorKey
    header: 'Exchange Date',
  },
  {
    // accessorKey: 'exchange_rate', //normal accessorKey
    header: 'Exchange Rate',
    accessorFn: (row) => Number(row.exchange_rate).toFixed(2),
  },
 
 
  {
    header: 'Amount',
    // accessorFn: (row) => `${row.amount}` +`${"MAD"} `,
    accessorFn: (row) => Number(row.amount).toFixed(2),
  },

 ];

  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title"> Balance Details</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/profile"> Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/invoices-payments">Invoice And Balances</Link>
                    </li>
                    <li className="breadcrumb-item active"> Balance Details</li>
                  </ul>
                </div>
             
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
              <div className="card customer-details-group">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-airplay2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-airplay "><g><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Company Name</h6>
                            <p>{value.company_name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-phone2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone "><g><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Phone Number</h6>
                            <p>{value.company_phone}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-mail2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail "><g><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Email Address</h6>
                            <p>{value.company_email}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-globe2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-globe "><g><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></g></svg></i></span>
                          <div className="customer-details-cont">
                            <h6>Website</h6>
                            <p>{value.company_website}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              </div>
            </div>

            <div className="row">
              
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Credit Balance</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus.credit_balance}</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Total Sales</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus.total_sale} </p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                       <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count">
                                  <div className="dash-title"> Total Paid</div>
                                  <div className="dash-counts">
                                    <p>{invoicestatus.total_paid} </p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
              </div>
              
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-table" style={{padding:'30px'}}>
                      <div className="card-body">
                              <ul className="nav nav-tabs nav-tabs-bottom">
                              
                            
                              <li className="nav-item">
                                  <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Invoices</a>                                  
                              </li>
                              <li className="nav-item">
                                  <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Payments</a>                                   
                              </li>                    
                              </ul>
                              <div className="tab-content">
                            
                              <div className="tab-pane show active" id="listing-groupby-supplier">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
        
                                        <MaterialReactTable columns={columns} data={data} 
                                            enableColumnOrdering
                                          />
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                                
                                </div>                                
                                <div className="tab-pane  " id="listing-all">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={payments_columns} data={paymentdata} 
                                            enableColumnOrdering
                                          />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                                
                                </div>                                
                              
                              </div>                             
                          </div>
                      </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerInvoicePayment;
